<!-- 选择测评模板 -->
<template>
  <el-form-item :label="label">
    <yx-cepingTemplate-selector @select="select" ref="child" @clear="reset" width="222px"/>
  </el-form-item>
</template>

<script>
import { inject, ref } from 'vue';

export default {
  kind: 'yq-测评模板选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number, Object],
      default: () => ({}),
    },
    label: {
      type: String,
      default: '测评模板：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');

    function reset() {
      child.value.clearField();
      // eslint-disable-next-line no-use-before-define
      cepingTemplate.value = {};
    }
    const cepingTemplate = useQuery('cepingTemplate', props.value, reset);

    function select(obj) {
      console.log(obj);
      cepingTemplate.value = obj;
    }

    return {
      select,
      child,
      reset,
      cepingTemplate,
    };
  },
};
</script>
